import React from "react";
import {removeProfile} from "../../logic_tmp/storage/LgProfile";

export function LgHome() {
    return (
        <div>
            <ul>
                <li><a href="/lgstart?utm_source=lg&utm_campaign=2023EU.C1.TRAFFIC.TestCmp&utm_medium=COLD.BADEN-WÜRTTEMBERG.RU.VIOLIN.S1-TestAud&utm_content=BELLACIAO_MARIA_VIDEO-TLN2022_12_29.A1&action=START">BellaCiao Masha Video Sturttgart</a></li>
                <li><a href="/lgstart?utm_source=lg&utm_campaign=2023EU.C1.TRAFFIC.TestCmp&utm_medium=COLD.BADEN-WÜRTTEMBERG.RU.VIOLIN.S1-TestAud&utm_content=MASQUERADE_SAMDAN_VIDEO-TLN2022_12_29.A1&action=START">Masquerade Video Sturttgart</a></li>
                <li><a href="/lgstart?utm_source=lg&utm_campaign=2023EU.C1.TRAFFIC.TestCmp&utm_medium=COLD.BADEN-WÜRTTEMBERG.RU.VIOLIN.S1-TestAud&utm_content=METELICA_ALEKSEI_VIDEO-TLN2022_12_29.A1&action=START">2 метелицы Video Sturttgart</a></li>
                <li><a href="/lgstart?utm_source=lg&utm_campaign=2023EU.C1.TRAFFIC.TestCmp&utm_medium=COLD.BADEN-WÜRTTEMBERG.RU.VIOLIN.S1-TestAud&utm_content=BASQUE_CAPRICCIO_SAM_VIDEO-TLN2022_12_29.A1&action=START">Баскское каприччио Video Sturttgart</a></li>
                <li><a href="/lgstart?utm_source=lg&utm_campaign=2023EU.C1.TRAFFIC.TestCmp&utm_medium=COLD.BADEN-WÜRTTEMBERG.RU.VIOLIN.S1-TestAud&utm_content=PIAZZOLLA_WINTER_SAMDAN_VIDEO-TLN2022_12_29.A1&action=START">Пьяцилла Зима  Video Sturttgart</a></li>
            </ul>
            <button onClick={()=>removeProfile()}>Remove Profile</button>
        </div>
    );
}

